import type { ReactNode } from "react";
import type { DocumentsSectionItem } from "@/Shared/Shipment/CustomComponents/ShipmentDocumentsSectionGeneric";
import ShipmentDocumentsSectionGeneric from "@/Shared/Shipment/CustomComponents/ShipmentDocumentsSectionGeneric";

export type { DocumentsSectionItem as ImageSectionItem };

interface ImageSectionProps {
  children?: ReactNode | undefined;
  items: Array<DocumentsSectionItem>;
  shipmentId?: string | undefined;
  onReload?: (() => Promise<void>) | undefined;
}

function ViewShipmentsImageSection(props: ImageSectionProps) {
  return (
    <ShipmentDocumentsSectionGeneric
      items={props.items}
      shipmentId={props.shipmentId}
      onReload={props.onReload}
      title="Images"
      subtitle="Here are all the images associated with your shipment."
      sectionId="images-section"
      thumbnailType="img"
    />
  );
}

export default ViewShipmentsImageSection;
